import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as relayAction from '../../actions/relays'


class RelaySort extends React.Component {
    onClickSort (id) {
        this.props.relaySetSort(id)
        this.props.relaySetLectureList(null)
        this.props.relaySetLectureOffset(0)
        this.props.relayFetchLectureList()
    }
    renderSortClass (id, selectedId) {
        return id === selectedId ? 'navbar-selected' : ''
    }
    render() {
        const { relaySort, tabId } = this.props
        if (tabId !== 0) return null
        return (
            <div className="box weui-padding border-bottom-line margin-bottom big-font margin-bottom">
                <a href="javascript:;" onClick={e => this.onClickSort('default')} className={`padding-right ${this.renderSortClass('default', relaySort)}`}>
                    <i className="iconfont icon-vip"></i>
                    精选
                </a>
                <a href="javascript:;" onClick={e => this.onClickSort('popular')} className={`padding-left border-left-line ${this.renderSortClass('popular', relaySort)}`}>
                    <i className="iconfont icon-huore-copy"></i>
                    最热
                </a>
            </div>
        )
    }
}


export default connect(state => ({
    relaySort: state.relay.relaySort,
    tabId: state.component.wkTab.selectId,
}), dispatch => bindActionCreators({ ...relayAction }, dispatch))(RelaySort)


// WEBPACK FOOTER //
// ./src/components/relays/RelaySort.js